









































import BaseComponent from "@/components/base/BaseComponent";
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SuccessPage extends BaseComponent {
  @Prop({ type: String, required: true }) fundType!: string;
  @Prop({ type: String, required: true }) memberName!: string;
  @Prop({ type: Number, required: true }) referenceNum!: number;

  handleCloseClick() {
    this.$emit('closeClick');
  }

  handleCreateNewProcessClick() {
    this.$emit('createNewClick');
  }
}
